import { useOutletContext } from 'react-router-dom'
import { User } from '../types'

export function useDashboardOutletContext() {
  return useOutletContext() as User
}
